import type {
  Billing,
  ChannelSlotDetails,
  Plan,
  BillingInterval,
  PricingTier,
  Subscription,
} from '../types'

const MOBILE_BILLING_GATEWAYS = new Set(['revenuecat', 'apple', 'android'])

export function isMobileBillingGateway(
  gatewayType: string | null | undefined,
): boolean {
  return (
    typeof gatewayType === 'string' && MOBILE_BILLING_GATEWAYS.has(gatewayType)
  )
}

export function getSubscriptionData(
  billingData: Billing,
): Subscription | undefined {
  return billingData.subscription
}

export function getSubscriptionPlanData(
  billingData?: Billing,
): Plan | undefined {
  return billingData?.subscription?.plan
}

export function getSubscriptionPlanId(
  billingData: Billing,
): string | undefined {
  return billingData?.subscription?.plan?.id
}

export function getSubscriptionInterval(
  billingData?: Billing,
): BillingInterval | undefined {
  return billingData?.subscription?.interval
}

export function getSubscriptionPeriodEnd(billingData: Billing): string | null {
  return billingData?.subscription?.periodEnd || null
}

export function getBillingChannelSlotDetails(
  billingData?: Billing,
): ChannelSlotDetails | undefined {
  return billingData?.channelSlotDetails
}

export function getPricingTiers(
  billingData: Billing,
): Array<PricingTier> | undefined {
  return billingData?.pricingTiers
}

export function isOnNonAgencyTieredPricing(billingData?: Billing): boolean {
  if (!billingData || !billingData.pricingTiers) {
    return false
  }
  // Non-agency tiered plans are the only ones with more than 2 pricing tiers
  return billingData.pricingTiers.length > 2
}
